import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../../../services/enumeration.service';

@Component({
  selector: 'app-modal-change-header-footer',
  templateUrl: './modal-change-header-footer.component.html',
  styles: [
  ]
})
export class ModalChangeHeaderFooterComponent extends ExcTranslation implements OnInit {
  @Input() data: any;
  commentModel = '';
  isHeader = true;
  constructor(
    public excRest: ExcRestService,
    public modal: ExgModalService,
    public excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    if (this.data.isHeader){ this.isHeader = true; }
    else { this.isHeader = false; }
    if (this.data.comment || this.data.comment === '') { this.commentModel = this.data.comment; }
  }

  close(): void {
    this.modal.close();
  }

  save(): void {
    if (this.commentModel || this.commentModel === '') {
      this.modal.action({comment: this.commentModel});
    }
    else {
      this.modal.action({comment: undefined});
    }
  }
}
